import {
  aboutUs,
  backmarketWarranty,
  boMerchant,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  help,
  hireExternal,
  infosConsumer,
  insurances,
  legal,
  medium,
  modelsComparison,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const beConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [
        aboutUs,
        hireExternal,
        { translationKey: 'pro', href: 'https://pro.backmarket.fr' },
      ],
      socials: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/black_market_be',
        },
        {
          name: 'facebook',
          href: 'https://www.facebook.com/BackMarketCom',
        },
        { name: 'x', href: 'https://x.com/back_market' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.be/fr-be/seller/home',
        },
        boMerchant,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/fr-be/articles/360026643854-Quels-sont-les-moyens-de-paiement-accept%C3%A9s-sur-Back-Market',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/fr-be/articles/360026646054-Dans-quel-pays-puis-je-me-faire-livrer-et-combien-cela-me-co%C3%BBte',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/fr-be/categories/360002106194-Retours-Remboursements-Retouren-en-terugbetalingen-Returns-refunds-',
        },
        insurances,
        help,
        buyingGuides,
        modelsComparison,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        backmarketWarranty,
        dataProtection,
        cookiePolicy,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/fr-be/requests/new?ticket_form_id=12226993197084',
        },
        { translationKey: 'paymentMethods', href: '' },
      ],
    },
    {
      titleKey: 'categoryHello',
      links: [
        {
          translationKey: 'trustpilot',
          href: 'https://fr.trustpilot.com/review/backmarket.be',
        },
        {
          translationKey: 'glassdoor',
          href: 'https://fr.glassdoor.be/Pr%C3%A9sentation/Travailler-chez-Back-Market-EI_IE1780208.16,27.htm',
        },
        medium,
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
